import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import LoginCard from "components/login/components/login-card";
import { findOrCreateSubmission, findOrCreateSubmissionVariables, getViewer } from "types/gql-types";
import { VIEWER_QUERY } from "components/auth/query";
import LoginModalContext from "components/login/context/modal";
import { LoadingSpinner } from "components/graphql-views";
import { useSnackbar } from "components/haven-design/snackbar";
import findOrCreateSubmissionQuery from "./find-or-create-submission.gql";

type AuthenticatedProps = {
  formId: string,
  interestListId: string,
  formType?: string,
  propertyName?: string,
  isSignup?: boolean
}

const Authenticated: React.FC<AuthenticatedProps> = ({ formId, formType, propertyName,
  isSignup, interestListId }) => {
  const navigate = useNavigate();
  const [fetchSubmission, { loading: mutationLoading }] = useMutation<
  findOrCreateSubmission, findOrCreateSubmissionVariables>(findOrCreateSubmissionQuery);
  const { loading, error, data, refetch } = useQuery<getViewer>(VIEWER_QUERY);
  const { openSnackbar } = useSnackbar();
  const query = new URLSearchParams(window.location.search);
  const returnTo = query.get("return-to");

  useEffect(() => {
    if (data && data.viewer) {
      if (returnTo) {
        navigate(returnTo);
      } else {
        fetchSubmission({ variables: { formId } })
          // @ts-ignore
          .then(({ data: { findOrCreateSubmission: { id: submissionId } } }) => {
            navigate(`/application/${submissionId}`);
          }).catch((caughtError) => {
            if (caughtError && caughtError.message === "user_has_active_interest") {
              openSnackbar({ message: "Already Applied. Please update information if needed.", status: "success" });
              navigate(`/dash/client/submissions/${interestListId}`);
            } else if (caughtError) {
              openSnackbar({
                message: "An error occurred while trying to create your application. Please try again later.",
                status: "error",
              });
              navigate("/");
            }
          });
      }
    }
  }, [loading, data, error]);

  const headerElem = formType && propertyName ? `${formType} for ${propertyName}` : "Welcome Back!";

  if (loading || mutationLoading) return <LoadingSpinner />;

  return (<LoginModalContext.Provider value={{ inModal: false }}>
    <LoginCard afterLogin={() => refetch()} formId={formId} isSignup={isSignup} headerText={headerElem} subheaderText="Please Log In to start" />
  </LoginModalContext.Provider>);


};

export default Authenticated;
